import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        category: {},
    },

    mutations: {
        setCategory(state, category) {
            state.category = category;
        },
    },
    actions: {
        async getCategory({ commit }, categoryId) {
            const response = await ApiClient.get(`/api/resources/${categoryId}`);
            commit('setCategory', response.data);
        },
    },
};
